const breadcrumb = [
    {
        id: '01',
        breadItem: 'Courses',
        link: '/dashboard/courses/my-courses'
    },
    {
        id: '02',
        breadItem: 'View Course'
    }
];

export const CreatelearningPathBreadcrumb = [
    {
        id: '01',
        breadItem: 'Learning Paths',
        link: '/dashboard/learning-path'
    },
    {
        id: '02',
        breadItem: 'Create Learning Path'
    }
];

export default breadcrumb;

export const circularBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Circular'
    }
];
export const allCoursesBreadcrumb = [
    {
        id: '01',
        breadItem: 'All Courses',
        link: '/dashboard/courses/all-courses'
    },
    {
        id: '02',
        breadItem: 'My Courses'
    }
];
export const mandatoryCoursesBreadcrumb = [
    {
        id: '01',
        breadItem: 'All Courses',
        link: '/dashboard/courses/all-courses'
    },
    {
        id: '02',
        breadItem: 'Mandatory Courses'
    }
];

export const trackProgressBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Courses',
        link: '/dashboard/courses/my-courses'
    },
    {
        id: '03',
        breadItem: 'Track Progress'
    }
];

export const StudentLearningPathBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Learning Paths'
    }
];

export const leaderboardBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Leaderboard'
    }
];

export const attendanceBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Attendance'
    }
];

export const attendanceDetailsBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Attendance',
        link: '/dashboard/attendance'
    },
    {
        id: '03',
        breadItem: 'Attendance Details'
    }
];

export const QuestionCategoryBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Courses',
        link: '/dashboard/courses/my-courses'
    },
    {
        id: '03',
        breadItem: 'Question Bank'
    }
];

export const recentlyDeletedBreadcrumb = [
    {
        id: '01',
        breadItem: 'Dashboard',
        link: '/dashboard'
    },
    {
        id: '02',
        breadItem: 'Courses',
        link: '/dashboard/courses/my-courses'
    },
    {
        id: '03',
        breadItem: 'Recently Deleted'
    }
];

export const AddQuestionBreadcrumb = [
    {
        id: '01',
        breadItem: 'Question Bank',
        link: '/dashboard/courses/question-bank'
    },
    {
        id: '02',
        breadItem: 'Add Question'
    }
];
